import PhoneArea from "components/PhonePreview/PhoneArea"
import React from "react"
import Boxes from "containers/AppSetup_ListScreen/LayoutPreviews/boxes"
import Cards from "containers/AppSetup_ListScreen/LayoutPreviews/cards"
import Carousel from "containers/AppSetup_ListScreen/LayoutPreviews/carousel"
import Circles from "containers/AppSetup_ListScreen/LayoutPreviews/circles"
import Grid from "containers/AppSetup_ListScreen/LayoutPreviews/grid"
import SimpleStack from "containers/AppSetup_ListScreen/LayoutPreviews/simpleStack"

const ThumbnailPreview = ({
  layout = "3",
  bgImage,
  bgColor,
  headerColor,
  headerImage,
  title = "",
  textColor,
  textFont,
  data,
}) => {
  const renderPreview = () => {
    switch (layout) {
      case "2":
        return (
          <Cards
            previewData={data}
            headerColor={headerColor}
            textColor={textColor}
          />
        )
      case "3":
        return (
          <Boxes
            previewData={data}
            headerColor={headerColor}
            textColor={textColor}
          />
        )
      case "4":
        return (
          <Carousel
            headerColor={headerColor}
            textColor={textColor}
            bgImage={data[0]?.img}
          />
        )
      case "5":
        return <Grid previewData={data} />
      case "6":
        return (
          <SimpleStack
            previewData={data}
            headerColor={headerColor}
            textColor={textColor}
          />
        )
      case "8":
        return (
          <Circles
            previewData={data}
            headerColor={headerColor}
            textColor={textColor}
          />
        )
      default:
        return <></>
    }
  }

  return (
    <PhoneArea>
      <div
        style={{
          backgroundImage: `url(${bgImage?.editedImage})`,
          backgroundColor: bgColor,
          width: "105%",
          height: "105%",
          backgroundSize: "cover",
          marginLeft: "-5px",
          backgroundPosition: "center center",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "50px",
            backgroundColor: headerColor,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <i
            className="bx bxs-home font-size-24"
            style={{
              color: textColor,
            }}
          />

          {headerImage && headerImage?.editedImage ? (
            layout === "6" || layout === "8" ? (
              <></>
            ) : (
              <div
                style={{
                  backgroundImage: `url(${headerImage?.editedImage})`,
                  width: "100px",
                  height: "auto",
                  backgroundSize: "contain",
                  minHeight: "50px",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              />
            )
          ) : (
            <p
              style={{
                paddingBlockStart: "1em",
                color: textColor,
                fontFamily: textFont,
              }}
            >
              {title}
            </p>
          )}
          <i
            className="bx bxs-user-circle font-size-24 me-2"
            style={{
              color: textColor,
            }}
          />
        </div>
        {headerImage &&
        headerImage?.editedImage &&
        (layout === "6" || layout === "8") ? (
          <div
            style={{
              backgroundImage: `url(${headerImage?.editedImage})`,
              width: "70%",
              height: "auto",
              backgroundSize: "contain",
              minHeight: "100px",
              maxHeight: "30%",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              margin: "0 auto",
            }}
          />
        ) : (
          <></>
        )}
        {renderPreview()}
        <div
          style={{
            width: "100%",
            height: "40px",
            position: "absolute",
            bottom: "0",
            left: "0",
            backgroundColor: "black",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            color: "white",
            padding: "10px",
          }}
        >
          <i className="bx bx-menu font-size-20" />
          <i className="mdi mdi-blur font-size-20" />
          <i className="bx bx-conversation font-size-20" />
        </div>
      </div>
    </PhoneArea>
  )
}

export default ThumbnailPreview
